module.exports = __webpack_public_path__ + "img/bg3.a8969b71.png";